// M13.1 — neutral channel palette for the macro source-mix section.
// Distinct from the social platform brand colours in `platform-colors.ts`
// so the SourceMixSection (channels) and PlatformLeaderboard / TimeSeries
// (platforms) never read as the same data when stacked on the dashboard.
//
// Anchored on the blurple family (purple-700 to purple-200) for the
// "owned" buckets (Direct, Organic Social, Paid Social, Email), warm
// amber for paid (Paid Search, Display), neutral slate for everything
// else, and a flat neutral grey for the "Other" rollup band.
//
// All 15 GA4 sessionDefaultChannelGroup buckets are mapped here
// verbatim. Any unknown channel value (eg. a future GA4 addition we
// haven't seen yet) falls back to OTHER_CHANNEL_COLOR so the chart never
// renders an undefined fill.

export const OTHER_CHANNEL_COLOR = "#A1A1AA"; // zinc-400 — used by the "Other" rollup band

export const CHANNEL_COLOR_HEX: Record<string, string> = {
  Direct: "#0E1680", // navy-900 — anchor blurple
  "Organic Search": "#7C5CFF", // violet-500 — high-value but inbound
  "Paid Search": "#F59E0B", // amber-500 — paid family
  "Organic Social": "#4F31FF", // blurple-600 — primary social
  "Paid Social": "#9583FF", // purple-400 — paid social
  Referral: "#06B6D4", // cyan-500 — neighbourly inbound
  Email: "#A855F7", // purple-500 — owned outbound
  Display: "#F97316", // orange-500 — paid display
  Affiliates: "#EC4899", // pink-500 — partner-driven
  Audio: "#14B8A6", // teal-500
  SMS: "#10B981", // emerald-500 — owned outbound
  Video: "#EF4444", // red-500
  "Mobile Push Notifications": "#84CC16", // lime-500 — owned outbound
  "Cross-network": "#6366F1", // indigo-500 — Google's blended bucket
  Unassigned: "#71717A", // zinc-500 — unknown / ungrouped
};

/** Lookup that always returns a valid hex (falls back to OTHER). */
export function channelColor(channel: string): string {
  return CHANNEL_COLOR_HEX[channel] ?? OTHER_CHANNEL_COLOR;
}
